import { ReactElement } from 'react';

import {
  ConditionalWrapper,
  Tooltip,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { FormSection } from './components/FormSection';
import { WoopAgentCommand } from '../../../_components/WoopAgentCommand';
import { minimumWoopAgentVersionForSingleResource } from '../../../_constants';
import { useVersionsInfo } from '../../../_hooks/useVersionsInfo';
import { vpaSettingsConstants } from '../../_constants/settingsConstants';
import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';

import { getDocsLink } from '@cast/utils';

type Props = {
  optimizedResourcesField: ReactElement;
};
export const OptimizedResourcesSettingsContainer = ({
  optimizedResourcesField,
}: Props) => {
  const { title, docsLinkKey, optimizedResources } =
    vpaSettingsConstants.optimizedResources;

  const { isSingleResourceModeCannotBeUsed } = useVersionsInfo();

  return (
    <VerticalSettingsForm title={title} docsLinkKey={docsLinkKey}>
      <ConditionalWrapper
        condition={isSingleResourceModeCannotBeUsed}
        wrapper={(child) => (
          <Tooltip
            title={
              <Stack
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                <div>
                  Update required:&nbsp;
                  <ExternalLink
                    link={getDocsLink('docs_woop_upgrading')}
                    noIcon
                  >
                    <Typography
                      variant="P12B"
                      color={tokens.theme.fg.selection.primary}
                    >
                      workload-autoscaler{' '}
                      {minimumWoopAgentVersionForSingleResource}
                    </Typography>
                  </ExternalLink>
                </div>
                <WoopAgentCommand />
              </Stack>
            }
          >
            {child}
          </Tooltip>
        )}
      >
        <FormSection
          title={optimizedResources.title}
          description={optimizedResources.description}
        >
          <div>{optimizedResourcesField}</div>
        </FormSection>
      </ConditionalWrapper>
    </VerticalSettingsForm>
  );
};
